import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BookMarked } from "lucide-react";

export default function Footer() {
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-[var(--border)] bg-[var(--bg)] mt-16"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-14 py-10 md:py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                <Link
                    to="/"
                    className="flex items-center gap-2 text-[var(--ink)]"
                    data-testid="footer-brand-link"
                >
                    <BookMarked size={16} strokeWidth={1.5} />
                    <span
                        className="font-display text-lg tracking-tight"
                        style={{ fontVariationSettings: '"wght" 600, "wdth" 90, "opsz" 32' }}
                    >
                        {t("nav.brand")}
                    </span>
                </Link>

                <nav
                    aria-label="footer"
                    className="flex flex-wrap items-center gap-x-6 gap-y-3 text-xs uppercase tracking-widest text-[var(--ink-muted)]"
                >
                    <Link
                        to="/privacidad"
                        data-testid="footer-privacy-link"
                        className="hover:text-[var(--accent)] transition-colors"
                    >
                        {t("footer.privacy")}
                    </Link>
                    <Link
                        to="/contacto"
                        data-testid="footer-contact-link"
                        className="hover:text-[var(--accent)] transition-colors"
                    >
                        {t("footer.contact")}
                    </Link>
                </nav>

                <p className="text-[10px] uppercase tracking-widest text-[var(--ink-dim)]">
                    © {year} {t("nav.brand")}
                </p>
            </div>
        </footer>
    );
}
